import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/forgot-password": [17],
		"/login": [18],
		"/(restricted)/projects": [4,[2]],
		"/(restricted)/projects/new": [6,[2]],
		"/(restricted)/projects/[projectId]/edit": [5,[2]],
		"/reset-password": [19],
		"/(restricted)/resumes": [7,[2]],
		"/(restricted)/resumes/new": [10,[2]],
		"/(restricted)/resumes/[resumeId]": [8,[2]],
		"/(restricted)/resumes/[resumeId]/edit": [9,[2]],
		"/(restricted)/skillcategories": [11,[2]],
		"/(restricted)/skillcategories/new": [13,[2]],
		"/(restricted)/skillcategories/[skillCategoryId]/edit": [12,[2]],
		"/(restricted)/skills": [14,[2]],
		"/(restricted)/skills/new": [16,[2]],
		"/(restricted)/skills/[skillId]/edit": [15,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';